const Joi = require('@hapi/joi')

export const schema = Joi.object({
  vacas_total_lactacao: Joi.number().min(0).required().messages({
    'number.base': `"vacas_total_lactacao" should be a type of 'number'`,
    'number.min': `"vacas_total_lactacao" should have a minimum length of {#limit}`,
    'any.required': `"vacas_total_lactacao" is a required field`
  }),
  vacas_inicio_lactacao: Joi.number().min(0).required().messages({
    'number.base': `"vacas_inicio_lactacao" should be a type of 'number'`,
    'number.min': `"vacas_inicio_lactacao" should have a minimum length of {#limit}`,
    'any.required': `"vacas_inicio_lactacao" is a required field`
  }),
  vacas_meio_lactacao: Joi.number().min(0).required().messages({
    'number.base': `"vacas_meio_lactacao" should be a type of 'number'`,
    'number.min': `"vacas_meio_lactacao" should have a minimum length of {#limit}`,
    'any.required': `"vacas_meio_lactacao" is a required field`
  }),
  vacas_fim_lactacao: Joi.number().min(0).required().messages({
    'number.base': `"vacas_fim_lactacao" should be a type of 'number'`,
    'number.min': `"vacas_fim_lactacao" should have a minimum length of {#limit}`,
    'any.required': `"vacas_fim_lactacao" is a required field`
  }),
  // Receita com Leite
  producao_media_leite: Joi.number().precision(2).required().messages({
    'number.base': `"producao_media_leite" should be a type of 'number'`,
    'number.precision': `"producao_media_leite" should have a decimal length of {#limit}`,
    'any.required': `"producao_media_leite" is a required field`
  }),
  producao_estimada_dia: Joi.number().min(0).required().messages({
    'number.base': `"producao_estimada_dia" should be a type of 'number'`,
    'number.min': `"producao_estimada_dia" should have a minimum length of {#limit}`,
    'any.required': `"producao_estimada_dia" is a required field`
  }),
  producao_estimada_mes: Joi.number().min(0).required().messages({
    'number.base': `"producao_estimada_mes" should be a type of 'number'`,
    'number.min': `"producao_estimada_mes" should have a minimum length of {#limit}`,
    'any.required': `"producao_estimada_mes" is a required field`
  }),
  consumo_mensal_familia_estimado: Joi.number().min(0).required().messages({
    'number.base': `"consumo_mensal_familia_estimado" should be a type of 'number'`,
    'number.min': `"consumo_mensal_familia_estimado" should have a minimum length of {#limit}`,
    'any.required': `"consumo_mensal_familia_estimado" is a required field`
  }),
  consumo_mensal_bezerras_estimado: Joi.number().min(0).required().messages({
    'number.base': `"consumo_mensal_bezerras_estimado" should be a type of 'number'`,
    'number.min': `"consumo_mensal_bezerras_estimado" should have a minimum length of {#limit}`,
    'any.required': `"consumo_mensal_bezerras_estimado" is a required field`
  }),
  quantidade_disponivel_venda: Joi.number().min(0).required().messages({
    'number.base': `"quantidade_disponivel_venda" should be a type of 'number'`,
    'number.min': `"quantidade_disponivel_venda" should have a minimum length of {#limit}`,
    'any.required': `"quantidade_disponivel_venda" is a required field`
  }),
  valor_pago_leite: Joi.number().precision(2).required().messages({
    'number.base': `"valor_pago_leite" should be a type of 'number'`,
    'number.precision': `"valor_pago_leite" should have a decimal length of {#limit}`,
    'any.required': `"valor_pago_leite" is a required field`
  }),
  receita_bruta_dia: Joi.number().precision(2).required().messages({
    'number.base': `"receita_bruta_dia" should be a type of 'number'`,
    'number.precision': `"receita_bruta_dia" should have a decimal length of {#limit}`,
    'any.required': `"receita_bruta_dia" is a required field`
  }),
  receita_bruta_mes: Joi.number().precision(2).required().messages({
    'number.base': `"receita_bruta_mes" should be a type of 'number'`,
    'number.precision': `"receita_bruta_mes" should have a decimal length of {#limit}`,
    'any.required': `"receita_bruta_mes" is a required field`
  }),
  receita_bruta_mes_leite: Joi.number().precision(2).required().messages({
    'number.base': `"receita_bruta_mes_leite" should be a type of 'number'`,
    'number.precision': `"receita_bruta_mes_leite" should have a decimal length of {#limit}`,
    'any.required': `"receita_bruta_mes_leite" is a required field`
  }),
  // Alimentação das Vacas em Lactação
  lactacao_custo_alimentacao_concentrada: Joi.number().precision(2).required().messages({
    'number.base': `"lactacao_custo_alimentacao_concentrada" should be a type of 'number'`,
    'number.precision': `"lactacao_custo_alimentacao_concentrada" should have a decimal length of {#limit}`,
    'any.required': `"lactacao_custo_alimentacao_concentrada" is a required field`
  }),
  lactacao_custo_alimentacao_volumosa: Joi.number().precision(2).required().messages({
    'number.base': `"lactacao_custo_alimentacao_volumosa" should be a type of 'number'`,
    'number.precision': `"lactacao_custo_alimentacao_volumosa" should have a decimal length of {#limit}`,
    'any.required': `"lactacao_custo_alimentacao_volumosa" is a required field`
  }),
  lactacao_total_alimentacao: Joi.number().precision(2).required().messages({
    'number.base': `"lactacao_total_alimentacao" should be a type of 'number'`,
    'number.precision': `"lactacao_total_alimentacao" should have a decimal length of {#limit}`,
    'any.required': `"lactacao_total_alimentacao" is a required field`
  }),
  // Alimentação das Vacas Secas e no Pré Parto
  pre_parto_custo_alimentacao_concentrada: Joi.number().precision(2).required().messages({
    'number.base': `"pre_parto_custo_alimentacao_concentrada" should be a type of 'number'`,
    'number.precision': `"pre_parto_custo_alimentacao_concentrada" should have a decimal length of {#limit}`,
    'any.required': `"pre_parto_custo_alimentacao_concentrada" is a required field`
  }),
  pre_parto_custo_alimentacao_volumosa: Joi.number().precision(2).required().messages({
    'number.base': `"pre_parto_custo_alimentacao_volumosa" should be a type of 'number'`,
    'number.precision': `"pre_parto_custo_alimentacao_volumosa" should have a decimal length of {#limit}`,
    'any.required': `"pre_parto_custo_alimentacao_volumosa" is a required field`
  }),
  pre_parto_total_alimentacao: Joi.number().precision(2).required().messages({
    'number.base': `"pre_parto_total_alimentacao" should be a type of 'number'`,
    'number.precision': `"pre_parto_total_alimentacao" should have a decimal length of {#limit}`,
    'any.required': `"pre_parto_total_alimentacao" is a required field`
  }),
  // Alimentação das Bezerras e Novilhas
  bezerras_custo_leite: Joi.number().precision(2).required().messages({
    'number.base': `"bezerras_custo_leite" should be a type of 'number'`,
    'number.precision': `"bezerras_custo_leite" should have a decimal length of {#limit}`,
    'any.required': `"bezerras_custo_leite" is a required field`
  }),
  bezerras_custo_alimentacao_concentrada: Joi.number().precision(2).required().messages({
    'number.base': `"bezerras_custo_alimentacao_concentrada" should be a type of 'number'`,
    'number.precision': `"bezerras_custo_alimentacao_concentrada" should have a decimal length of {#limit}`,
    'any.required': `"bezerras_custo_alimentacao_concentrada" is a required field`
  }),
  bezerras_custo_alimentacao_volumosa: Joi.number().precision(2).required().messages({
    'number.base': `"bezerras_custo_alimentacao_volumosa" should be a type of 'number'`,
    'number.precision': `"bezerras_custo_alimentacao_volumosa" should have a decimal length of {#limit}`,
    'any.required': `"bezerras_custo_alimentacao_volumosa" is a required field`
  }),
  bezerras_total_alimentacao: Joi.number().precision(2).required().messages({
    'number.base': `"bezerras_total_alimentacao" should be a type of 'number'`,
    'number.precision': `"bezerras_total_alimentacao" should have a decimal length of {#limit}`,
    'any.required': `"bezerras_total_alimentacao" is a required field`
  }),
  // Alimentação do Rebanho
  rebanho_custo_leite: Joi.number().precision(2).required().messages({
    'number.base': `"rebanho_custo_leite" should be a type of 'number'`,
    'number.precision': `"rebanho_custo_leite" should have a decimal length of {#limit}`,
    'any.required': `"rebanho_custo_leite" is a required field`
  }),
  rebanho_custo_alimentacao_concentrada: Joi.number().precision(2).required().messages({
    'number.base': `"rebanho_custo_alimentacao_concentrada" should be a type of 'number'`,
    'number.precision': `"rebanho_custo_alimentacao_concentrada" should have a decimal length of {#limit}`,
    'any.required': `"rebanho_custo_alimentacao_concentrada" is a required field`
  }),
  rebanho_custo_alimentacao_volumosa: Joi.number().precision(2).required().messages({
    'number.base': `"rebanho_custo_alimentacao_volumosa" should be a type of 'number'`,
    'number.precision': `"rebanho_custo_alimentacao_volumosa" should have a decimal length of {#limit}`,
    'any.required': `"rebanho_custo_alimentacao_volumosa" is a required field`
  }),
  rebanho_custo_alimentacao: Joi.number().precision(2).required().messages({
    'number.base': `"rebanho_custo_alimentacao" should be a type of 'number'`,
    'number.precision': `"rebanho_custo_alimentacao" should have a decimal length of {#limit}`,
    'any.required': `"rebanho_custo_alimentacao" is a required field`
  }),
  // Custo da suplementação mineral
  vacas_lactacao_custo_mineral: Joi.number().precision(2).required().messages({
    'number.base': `"vacas_lactacao_custo_mineral" should be a type of 'number'`,
    'number.precision': `"vacas_lactacao_custo_mineral" should have a decimal length of {#limit}`,
    'any.required': `"vacas_lactacao_custo_mineral" is a required field`
  }),
  pre_parto_custo_mineral: Joi.number().precision(2).required().messages({
    'number.base': `"pre_parto_custo_mineral" should be a type of 'number'`,
    'number.precision': `"pre_parto_custo_mineral" should have a decimal length of {#limit}`,
    'any.required': `"pre_parto_custo_mineral" is a required field`
  }),
  bezerras_custo_mineral: Joi.number().precision(2).required().messages({
    'number.base': `"bezerras_custo_mineral" should be a type of 'number'`,
    'number.precision': `"bezerras_custo_mineral" should have a decimal length of {#limit}`,
    'any.required': `"bezerras_custo_mineral" is a required field`
  }),
  total_custo_mineral: Joi.number().precision(2).required().messages({
    'number.base': `"total_custo_mineral" should be a type of 'number'`,
    'number.precision': `"total_custo_mineral" should have a decimal length of {#limit}`,
    'any.required': `"total_custo_mineral" is a required field`
  }),
  // Sobras (com relação à alimentação)
  sobra_receita_estimada: Joi.number().precision(2).required().messages({
    'number.base': `"sobra_receita_estimada" should be a type of 'number'`,
    'number.precision': `"sobra_receita_estimada" should have a decimal length of {#limit}`,
    'any.required': `"sobra_receita_estimada" is a required field`
  }),
  sobra_despesa_estimada: Joi.number().precision(2).required().messages({
    'number.base': `"sobra_despesa_estimada" should be a type of 'number'`,
    'number.precision': `"sobra_despesa_estimada" should have a decimal length of {#limit}`,
    'any.required': `"sobra_despesa_estimada" is a required field`
  }),
  sobra_total_estimada: Joi.number().precision(2).required().messages({
    'number.base': `"sobra_total_estimada" should be a type of 'number'`,
    'number.precision': `"sobra_total_estimada" should have a decimal length of {#limit}`,
    'any.required': `"sobra_total_estimada" is a required field`
  }),
  // Qualidade
  qualidade_rtm_pb: Joi.number().precision(2).required().messages({
    'number.base': `"qualidade_rtm_pb" should be a type of 'number'`,
    'number.precision': `"qualidade_rtm_pb" should have a decimal length of {#limit}`,
    'any.required': `"qualidade_rtm_pb" is a required field`
  }),
  qualidade_rtm_ndt: Joi.number().precision(2).required().messages({
    'number.base': `"qualidade_rtm_ndt" should be a type of 'number'`,
    'number.precision': `"qualidade_rtm_ndt" should have a decimal length of {#limit}`,
    'any.required': `"qualidade_rtm_ndt" is a required field`
  }),
  // Custos
  custo_racao_concentrada: Joi.number().precision(2).required().messages({
    'number.base': `"custo_racao_concentrada" should be a type of 'number'`,
    'number.precision': `"custo_racao_concentrada" should have a decimal length of {#limit}`,
    'any.required': `"custo_racao_concentrada" is a required field`
  }),
  custo_racao_volumosa: Joi.number().precision(2).required().messages({
    'number.base': `"custo_racao_volumosa" should be a type of 'number'`,
    'number.precision': `"custo_racao_volumosa" should have a decimal length of {#limit}`,
    'any.required': `"custo_racao_volumosa" is a required field`
  }),
  custo_racao_total: Joi.number().precision(2).required().messages({
    'number.base': `"custo_racao_total" should be a type of 'number'`,
    'number.precision': `"custo_racao_total" should have a decimal length of {#limit}`,
    'any.required': `"custo_racao_total" is a required field`
  }),
  custo_alimentacao_litro: Joi.number().precision(2).required().messages({
    'number.base': `"custo_alimentacao_litro" should be a type of 'number'`,
    'number.precision': `"custo_alimentacao_litro" should have a decimal length of {#limit}`,
    'any.required': `"custo_alimentacao_litro" is a required field`
  })
})
